import axios from 'axios';
import React, { useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import constant from '../../utils/Constant';
import config from '../../config/config';
import Loader from '../partials/Loader';

const {
    STATUS_200,
    UPDATE_PROFILE_END_POINT,
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    STATUS_401,
    LOGOUT,
    S3_BASE_URL
} = constant;

const Profile = () => {
    const navigate = useNavigate();
    const profileName = localStorage.getItem('vendor_dashboard_name');
    const profileEmail = localStorage.getItem('vendor_dashboard_email');
    const profileImage = localStorage.getItem('vendor_dashboard_image');

    const fileInputRef = useRef(null);
    const [image, setImage] = useState(S3_BASE_URL + '/' + profileImage || "https://eventpro.workupdates.online/storage/images/17410746643929.jpg");
    const [loading, setLoading] = useState(falseValue);
    const [disable, setDisable] = useState(falseValue);
    const [name, setName] = useState(profileName);

    // * get token from local storage
    const token = localStorage.getItem('vendor_dashboard');

    // * handle change image
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith("image/")) {
            const imageURL = URL.createObjectURL(file);
            setImage(imageURL);
        }
    };

    // * remove image
    const handleRemoveImage = () => {
        setImage(null);
        fileInputRef.current.value = null;
    };

    // * execute update service
    const executeUpdateProfileApi = async () => {

        //* validation
        if (!name) {
            toast.error('Name is required!');
            return;
        }

        setLoading(trueValue);
        setDisable(trueValue);

        const data = new FormData();
        const img = document.getElementById('dropify-event');
        data.append('image', img.files[0]);
        data.append('name', name);

        try {
            const apiUrl = config.appBaseUrl + UPDATE_PROFILE_END_POINT;

            //* post request
            const response = await axios.post(apiUrl, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            //* response success
            const result = response.data;
            if (result.code === STATUS_200 && result.status) {
                toast.success(result.message);
                localStorage.setItem('vendor_dashboard_name', result.data.name);
                localStorage.setItem('vendor_dashboard_email', result.data.email);
                localStorage.setItem('vendor_dashboard_image', result.data.image);

                //* dispatch event after updating localStorage
                window.dispatchEvent(new Event('profileUpdated'));
            } else {
                toast.error(result.message);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);

            // * if user is unauthorized
            if (error?.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setDisable(falseValue);
            setLoading(falseValue);
        }
    };

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex  align-items-start align-items-sm-center justify-content-between gap-2">
                                <h4 className="mb-0">Update Profile</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Update Profile</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6">
                            <div className="card">
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label htmlFor="validationCustom01" className="form-label">
                                                    Image
                                                </label>
                                                <div className="dropify-wrapper has-preview">
                                                    <div className="dropify-message">
                                                        <span className="file-icon">
                                                            <p>Drag and drop a file</p>
                                                        </span>
                                                        <p className="dropify-error">Ooops, something wrong appended.</p>
                                                    </div>

                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        id="dropify-event"
                                                        name="image"
                                                        accept="image/png,image/jpg,image/jpeg"
                                                        onChange={handleImageChange}
                                                    />

                                                    {image && (
                                                        <div className="dropify-preview" style={{ display: "block" }}>
                                                            <span className="dropify-render">
                                                                <img src={image} alt="Preview" />
                                                            </span>
                                                            <div className="dropify-infos">
                                                                <div className="dropify-infos-inner">
                                                                    <p className="dropify-filename">
                                                                        <span className="file-icon" />
                                                                        <span className="dropify-filename-inner">
                                                                            {image.split("/").pop()}
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <button type="button" className="dropify-clear" onClick={handleRemoveImage}>
                                                                Remove
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-8  mt-3 mt-md-0">
                                                <div className="row">
                                                    {/* //* name */}
                                                    <div className="col-12 col-md-6 col-lg-12 col-xl-12 col-xxl-12">
                                                        <div className="mb-3">
                                                            <label
                                                                htmlFor="validationCustom01"
                                                                className="form-label"
                                                            >
                                                                Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control m-0"
                                                                name="name"
                                                                placeholder="Enter first name"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* //* email */}
                                                    <div className="col-12 col-md-6 col-lg-12 col-xl-12 col-xxl-12">
                                                        <div className="mb-3">
                                                            <label
                                                                htmlFor="validationCustom01"
                                                                className="form-label"
                                                            >
                                                                Email
                                                            </label>
                                                            <input
                                                                type="email"
                                                                className="form-control m-0"
                                                                name="email"
                                                                placeholder="Enter email"
                                                                defaultValue={profileEmail}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-end mt-1 mt-md-3'>
                                                <button className="btn btn-dark text-white" type="button" onClick={executeUpdateProfileApi} disabled={disable}>
                                                    {!loading ? 'Submit' : <Loader />}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Profile;